module.exports = __webpack_public_path__ + "static/media/12.886a1ce2.jpg";